import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '@fontsource/montserrat';
import App from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';

const domNode = document.getElementById('root');
const reactNode = <App />;

if (domNode.hasChildNodes()) {
  const root = hydrateRoot(domNode, reactNode);
  root.render(reactNode);
} else {
  const root = createRoot(domNode);
  root.render(reactNode);
}
